var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "320px" },
            attrs: {
              clearable: "",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              type: "daterange",
              "range-separator": "至",
              "start-placeholder": "电访生成开始时间",
              "end-placeholder": "结束时间"
            },
            model: {
              value: _vm.createTime,
              callback: function($$v) {
                _vm.createTime = $$v
              },
              expression: "createTime"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "230px" },
              attrs: { clearable: "", placeholder: "请选择电访任务" },
              model: {
                value: _vm.listQuery.campaignId,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "campaignId", $$v)
                },
                expression: "listQuery.campaignId"
              }
            },
            _vm._l(_vm.campaigns, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "180px" },
              attrs: { clearable: "", placeholder: "请选择客服" },
              model: {
                value: _vm.listQuery.userId,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "userId", $$v)
                },
                expression: "listQuery.userId"
              }
            },
            _vm._l(_vm.sysUsers, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.userName, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: [
                    "GET /admin/builtRecovery/list",
                    "POST /admin/builtRecovery/assignTask"
                  ],
                  expression:
                    "['GET /admin/builtRecovery/list', 'POST /admin/builtRecovery/assignTask']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v("查找")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "正在查询中。。。",
            "element-loading-background": "rgba(255, 255, 255, 0.2)",
            border: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "任务优先级",
              prop: "campaignLevel"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "电访类型",
              prop: "campaignCategory"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "电访名称", prop: "campaignName" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "描述", prop: "campaignRemark" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "N访数据", prop: "ntotal" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "1访数据", prop: "ftotal" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "已访数据", prop: "closed" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "手动关闭数据",
              prop: "manualClosed"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "TTL", prop: "ttl" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "任务数量和操作",
              width: "220",
              "class-name": "small-padding fixed-width"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.ntotal > 0 || scope.row.ftotal > 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["POST /admin/builtRecovery/assignTask"],
                                expression:
                                  "['POST /admin/builtRecovery/assignTask']"
                              }
                            ],
                            attrs: {
                              type: "text",
                              icon: "el-icon-refresh",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleAssigned(scope.row)
                              }
                            }
                          },
                          [_vm._v("任务转交")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.ntotal > 0 || scope.row.ftotal > 0
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["POST /admin/builtRecycle/closed"],
                                expression:
                                  "['POST /admin/builtRecycle/closed']"
                              }
                            ],
                            staticStyle: { color: "red" },
                            attrs: {
                              type: "text",
                              icon: "el-icon-close",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleClosed(scope.row)
                              }
                            }
                          },
                          [_vm._v("任务取消")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0"
          }
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "待拨打任务取消",
            visible: _vm.closedFormVisible,
            width: "630px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.closedFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "closedForm",
              attrs: {
                rules: _vm.rules,
                "status-icon": "",
                "label-position": "left",
                "label-width": "100px",
                model: _vm.closedForm
              }
            },
            [
              _c("el-form-item", { attrs: { label: "可取消数量" } }, [
                _vm._v(
                  "\n        (" +
                    _vm._s(_vm.closedForm.closedTitle) +
                    ")\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "取消1访数", prop: "ftotal" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { clearable: "", placeholder: "请输入需取消的数量" },
                    model: {
                      value: _vm.closedForm.ftotal,
                      callback: function($$v) {
                        _vm.$set(_vm.closedForm, "ftotal", _vm._n($$v))
                      },
                      expression: "closedForm.ftotal"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "取消N访数", prop: "ntotal" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { clearable: "", placeholder: "请输入需取消的数量" },
                    model: {
                      value: _vm.closedForm.ntotal,
                      callback: function($$v) {
                        _vm.$set(_vm.closedForm, "ntotal", _vm._n($$v))
                      },
                      expression: "closedForm.ntotal"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "取消原因", prop: "closedResult" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入取消原因" },
                    model: {
                      value: _vm.closedForm.closedResult,
                      callback: function($$v) {
                        _vm.$set(_vm.closedForm, "closedResult", $$v)
                      },
                      expression: "closedForm.closedResult"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.closedFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmClosed }
                },
                [_vm._v("确定取消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "任务转交",
            visible: _vm.dialogAssignedVisible,
            width: "750px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogAssignedVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                rules: _vm.rules,
                "status-icon": "",
                "label-position": "left",
                "label-width": "150px",
                model: _vm.assignForm
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "待分配N访", prop: "needAssignedUser" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      directives: [
                        {
                          name: "removeAriaHidden",
                          rawName: "v-removeAriaHidden"
                        }
                      ],
                      on: { change: _vm.handleRadioChange },
                      model: {
                        value: _vm.assignForm.needAssignedUser,
                        callback: function($$v) {
                          _vm.$set(_vm.assignForm, "needAssignedUser", $$v)
                        },
                        expression: "assignForm.needAssignedUser"
                      }
                    },
                    _vm._l(_vm.nUserList, function(user) {
                      return _c("el-radio", { attrs: { label: user.userId } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(user.userName) +
                            "-共" +
                            _vm._s(user.nttl) +
                            "个\n          "
                        )
                      ])
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分配到坐席", prop: "checkedUser" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      on: { change: _vm.handleChecked },
                      model: {
                        value: _vm.assignForm.checkedUser,
                        callback: function($$v) {
                          _vm.$set(_vm.assignForm, "checkedUser", $$v)
                        },
                        expression: "assignForm.checkedUser"
                      }
                    },
                    _vm._l(_vm.sysUsers, function(user) {
                      return _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: user.id != _vm.assignForm.nUserId,
                              expression: "user.id != assignForm.nUserId"
                            }
                          ],
                          attrs: { label: user.id }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(user.userName) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_vm._v("分配明细如下：")]),
              _vm._v(" "),
              _vm._l(_vm.assignedUsers, function(item, index) {
                return _c(
                  "el-form-item",
                  {
                    key: index,
                    attrs: {
                      label: item.userName + " 分配数量",
                      prop: "assignedNum"
                    }
                  },
                  [
                    _vm._v("\n        N访数据："),
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: {
                        type: "number",
                        clearable: "",
                        placeholder: "请输入" + item.userName + "分配数量"
                      },
                      model: {
                        value: item.ntotal,
                        callback: function($$v) {
                          _vm.$set(item, "ntotal", _vm._n($$v))
                        },
                        expression: "item.ntotal"
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-close",
                      staticStyle: { "font-size": "15px", cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.handleRemoveUser(item, index)
                        }
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogAssignedVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateAssigned }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }